// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f43073a9","225":"19074929","787":"b6f8d5e5"}[chunkId] + ".chunk.js";
};